import type { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { selectLoggedInUserInfo } from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanReadEscalation = (): boolean => {
  const user = useAppSelector(selectLoggedInUserInfo);

  const readPermissionAll: UserPermission = {
    resource: 'escalation',
    action: 'readbasic',
    scope: 'all',
  };

  const canReadAll = useHasPermission(user, readPermissionAll);
  return canReadAll;
};
